module.exports = __webpack_public_path__ + "mx.c462fbca5f8f57fd399d.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/mx.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/mx.svg
// module chunks = styles